import { render, staticRenderFns } from "./DoctorModal.vue?vue&type=template&id=46be7d4e&scoped=true"
import script from "./DoctorModal.vue?vue&type=script&lang=js"
export * from "./DoctorModal.vue?vue&type=script&lang=js"
import style0 from "./DoctorModal.vue?vue&type=style&index=0&id=46be7d4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46be7d4e",
  null
  
)

export default component.exports